import { ConnectForm } from "lib/core/components/forms"
import ConnectStores from "lib/core/store/components/ConnectStores"
import {
  ContentMethodEmbed,
  ContentMethodFormWrapper
} from "library/show/components/content/manage/methods"

// FORM

const fieldsData = {
  content_embed_code: {
    placeholder: "Paste embed code to reading document",
    action_prompt: "Load reading"
  }
}

const AssessmentEmbed = ({ fieldsData, handleSubmit }) => (
  <ContentMethodFormWrapper onSubmit={handleSubmit}>
    <ContentMethodEmbed
      defaultMode="embed_code"
      allowToggle={false}
      codeProps={fieldsData.content_embed_code}
    />
  </ContentMethodFormWrapper>
)

const AssessmentEmbedForm = ConnectForm(AssessmentEmbed, fieldsData)
AssessmentEmbedForm.displayName = "AssessmentEmbedForm"

// FORM CONTAINER

const mapStateToProps = function (state, ownProps) {
  const { selection } = state.contentAdminStore.state

  const content_embed_code =
    __guard__(
      selection != null ? selection.assessment : undefined,
      (x) => x.content_embed_code
    ) ||
    (selection != null ? selection.external_instructions : undefined) ||
    (selection != null ? selection.listed_instructions : undefined)

  const fieldValues = { content_embed_code }

  return _.assign(
    {},
    {
      fieldValues
    },
    ownProps
  )
}

const stores = [{ store: "contentAdmin", watch: ["selection"] }]

export default ConnectStores(AssessmentEmbedForm, stores, {}, mapStateToProps)

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
